import { createAction } from 'redux-actions';

export const startShareLinkByEmailSubmit = createAction('START_SHARE_LINK_BY_EMAIL_SUBMIT');

export const resolveShareLinkByEmailSubmit = createAction('RESOLVE_SHARE_LINK_BY_EMAIL_SUBMIT');

export const getShareLink = createAction('GET_SHARE_LINK');
